import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import crmService from "../../crmConfig.json";
import { crmAxios } from "../../app/crmApi";
import { errorToast } from "../../helpers/toaster";

const initialState = {
    inquiriesReport: { summary: {}, inquiries: [], pagination: { page: 1, limit: 20, total: 0, totalPages: 0 } },
    revenueReport: { summary: {}, trend: [], quotations: [], pagination: { page: 1, limit: 20, total: 0, totalPages: 0 } },
    agentPerformanceReport: { agents: [] },
    loading: false,
};

export const fetchInquiriesReportAsync = createAsyncThunk(
    "crmReport/fetchInquiries",
    async (params, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(crmService.reportInquiries, { params });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const fetchRevenueReportAsync = createAsyncThunk(
    "crmReport/fetchRevenue",
    async (params, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(crmService.reportRevenue, { params });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const fetchAgentPerformanceReportAsync = createAsyncThunk(
    "crmReport/fetchAgentPerformance",
    async (params, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(crmService.reportAgentPerformance, { params });
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

const crmReportSlice = createSlice({
    name: "crmReport",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchInquiriesReportAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchInquiriesReportAsync.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.success) state.inquiriesReport = payload.data;
            })
            .addCase(fetchInquiriesReportAsync.rejected, (state, { payload }) => {
                state.loading = false;
                errorToast(payload?.message || "Failed to load inquiries report");
            })
            .addCase(fetchRevenueReportAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchRevenueReportAsync.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.success) state.revenueReport = payload.data;
            })
            .addCase(fetchRevenueReportAsync.rejected, (state, { payload }) => {
                state.loading = false;
                errorToast(payload?.message || "Failed to load revenue report");
            })
            .addCase(fetchAgentPerformanceReportAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAgentPerformanceReportAsync.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.success) state.agentPerformanceReport = payload.data;
            })
            .addCase(fetchAgentPerformanceReportAsync.rejected, (state, { payload }) => {
                state.loading = false;
                errorToast(payload?.message || "Failed to load agent performance report");
            });
    },
});

export const selectInquiriesReport = (state) => state.crmReport.inquiriesReport;
export const selectRevenueReport = (state) => state.crmReport.revenueReport;
export const selectAgentPerformanceReport = (state) => state.crmReport.agentPerformanceReport;
export const selectReportLoading = (state) => state.crmReport.loading;

export default crmReportSlice.reducer;
